import { useEffect } from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { addressHistoryState } from './addressHistoryState'
import { importLoadState, isAllowedAddressHistoryState, isFetchedAddressHistoryState, isReadyState } from '../../store/loadingState'
import { addressApis } from '../../address/Apis'

export function useAddressHistory({ baId, token, userCountry, webCountry }: { baId: string; token: string; userCountry: string; webCountry: string }) {
    const [addressHistory, setAddressHistory] = useAtom(addressHistoryState)
    const [loading, setLoading] = useAtom(importLoadState)
    const [isFetched, setIsFetched] = useAtom(isFetchedAddressHistoryState)
    const [isAllowed, setIsAllowed] = useAtom(isAllowedAddressHistoryState)
    const isReady = useAtomValue(isReadyState)

    const getAddressHistory = async () => {
        try {
            if (userCountry.slice(0, 2) === webCountry.slice(0, 2)) {
                const response = await addressApis.getAddressHistory({ baId, ushopCountryCode: webCountry, token })
                const data = response.data
                if (data.mainAddress === null) {
                    data.mainAddress = data.items[0]
                    data.items.splice(0, 1)
                }
                setAddressHistory(data)
                setLoading(prev => ({ ...prev, addressHistory: false }))
                setIsFetched(true)
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(prev => ({ ...prev, addressHistory: false }))
            setIsFetched(true)
        }
    }

    const getAddressHistoryByHydra = async () => {
        const response = await addressApis.getAddressHistoryByHydra({ token })
        const data = response.data
        setAddressHistory(data)
    }

    useEffect(() => {
        if (!isReady) {
            if (userCountry.slice(0, 2) === webCountry.slice(0, 2) && addressHistory.login_id.length === 0) {
                setLoading(prev => ({ ...prev, addressHistory: true }))
                setIsAllowed(true)
            } else {
                setIsAllowed(false)
                setLoading(prev => ({ ...prev, addressHistory: false }))
                setIsFetched(true)
            }
        }
    }, [userCountry, webCountry, isReady])

    useEffect(() => {
        if (loading.addressHistory) {
            console.log('getAddressHistory')
            getAddressHistory()
        }
    }, [loading.addressHistory])

    return { addressHistory, setAddressHistory, isFetched, getAddressHistory, isAllowed, getAddressHistoryByHydra }
}
